import { cn } from '../../utils/cn';

interface PartnershipPriorityBadgeProps {
  priority: number;
  size?: 'sm' | 'md';
  className?: string;
}

const getPriorityConfig = (priority: number) => {
  if (priority >= 9) return { tone: 'badge-danger', label: 'Critical' };
  if (priority >= 7) return { tone: 'badge-orange', label: 'High' };
  if (priority >= 4) return { tone: 'badge-warning', label: 'Medium' };
  return { tone: 'badge-neutral', label: 'Low' };
};

export const PartnershipPriorityBadge = ({
  priority,
  size = 'sm',
  className,
}: PartnershipPriorityBadgeProps) => {
  const config = getPriorityConfig(priority);

  return (
    <span
      className={cn(
        'badge font-semibold',
        config.tone,
        size === 'md' && 'text-xs px-2.5 py-1',
        priority >= 9 && 'animate-pulse-slow',
        className
      )}
      title={`Priority: ${priority}/10 (${config.label})`}
    >
      P{priority}
    </span>
  );
};
